import React, { useRef } from 'react';
import { useLatest, useClickAway } from 'ahooks';

import './index.scss';

interface AIPageNavigationErrorProps {
  errorMessage: string;
  backText: string;
  onBack: (e: React.MouseEvent) => void;
  onClose?: () => void;
}

const AIPageNavigationError: React.FC<AIPageNavigationErrorProps> = (props) => {
  const { errorMessage, backText, onBack, onClose } = props;

  const wrapperRef = useRef<HTMLDivElement>(null);
  const onCloseRef = useLatest(onClose);

  useClickAway(() => {
    onCloseRef.current?.();
  }, wrapperRef);

  return (
    <div className="dbh-ai-search-error-wrapper" ref={wrapperRef}>
      <div className="dbh-ai-search-error-text">{errorMessage}</div>
      <div className="dbh-ai-search-back-button" onClick={onBack}>
        {backText}
      </div>
    </div>
  );
};

export default AIPageNavigationError;
